
import Vue from "vue"
import { getV4Home } from "~/scripts/useful-functions"

export default Vue.extend({
  name: "AnyVanLogo",

  props: {
    color: {
      type: String,
      default: "white"
    },
    width: {
      type: Number,
      default: 140
    },
    height: {
      type: Number,
      default: 24
    },
    full: {
      type: Boolean,
      default: true
    },
    withoutLink: {
      type: Boolean
    }
  },

  computed: {
    homeLink(): string {
      return getV4Home(this.$config.v4Host, this.$i18n.locale)
    }
  }
})
